module.exports = __webpack_public_path__ + "home-live-verify-right-f392b3bc.png";